import { render, staticRenderFns } from "./AnticipationsHeader.vue?vue&type=template&id=241b7924&scoped=true"
import script from "./AnticipationsHeader.vue?vue&type=script&lang=js"
export * from "./AnticipationsHeader.vue?vue&type=script&lang=js"
import style0 from "./AnticipationsHeader.vue?vue&type=style&index=0&id=241b7924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b7924",
  null
  
)

export default component.exports